import { render, staticRenderFns } from "./switchRecord.vue?vue&type=template&id=bc818672&scoped=true&"
import script from "./switchRecord.vue?vue&type=script&lang=js&"
export * from "./switchRecord.vue?vue&type=script&lang=js&"
import style0 from "./switchRecord.vue?vue&type=style&index=0&id=bc818672&lang=less&scoped=true&"
import style1 from "./switchRecord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc818672",
  null
  
)

export default component.exports